import React, { ChangeEvent, FC, useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../../components/Button";
import ButtonPrimary from "../../../../components/ButtonPrimary";
import Modal from "../../../../components/Modal";
import { ModalHeader } from "../../../../components/Modal/ModalHeader";
import { ModalContent } from "../../../../components/Modal/ModalContent";
import { ModalFooter } from "../../../../components/Modal/ModalFooter";
import FormGroup from "../../../../components/FormGroup";
import Label from "../../../../components/Label";
import Input from "../../../../components/Input";
import { getDateString } from "../../../../utils/common";
import { DateRangeModalProps } from "./types";

import "./styles.scss";

export const DateRangeModal: FC<DateRangeModalProps> = ({
  onSubmit,
  onDismiss,
  isOpen = false,
}) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { t } = useTranslation();
  const maxStartDate = endDate || getDateString(new Date());
  const minEndDate = startDate;
  const maxEndDate = getDateString(new Date());
  const canSubmit = Boolean(startDate) && Boolean(endDate);

  const handleSubmit = () => {
    onSubmit([startDate, endDate]);
  };

  const handleDismiss = () => {
    onDismiss();
  };

  const handleStartDateChange = (event: ChangeEvent<HTMLInputElement>) => {
    const date = event.target.value;
    if (date > maxStartDate) {
      setStartDate(maxStartDate);
      return;
    }
    setStartDate(date);
  };

  const validateEndDate = (event: ChangeEvent<HTMLInputElement>) => {
    if (endDate > maxEndDate) {
      setEndDate(maxEndDate);
      return;
    }

    if (endDate < minEndDate) {
      setEndDate(minEndDate);
      return;
    }
  };

  const handleEndDateChange = (event: ChangeEvent<HTMLInputElement>) => {
    const date = event.target.value;
    setEndDate(date);
  };

  return (
    <Modal className="date-range-modal" isOpen={isOpen} id="date-range-modal">
      <ModalHeader>{t("customDateRange")}</ModalHeader>
      <ModalContent>
        <form className="date-range-modal__form">
          <FormGroup>
            <Label>{t("startDate")}</Label>
            <Input
              type="date"
              name="start-date"
              value={startDate}
              onChange={handleStartDateChange}
              id="start-date-input"
            />
          </FormGroup>
          <FormGroup>
            <Label>{t("endDate")}</Label>
            <Input
              type="date"
              name="end-date"
              value={endDate}
              onChange={handleEndDateChange}
              onBlur={validateEndDate}
              id="end-date-input"
            />
          </FormGroup>
        </form>
      </ModalContent>
      <ModalFooter className="date-range-modal__footer">
        <Button
          onClick={handleDismiss}
          className="ams-modal__action"
          id="cancel-button"
        >
          Cancel
        </Button>
        <ButtonPrimary
          onClick={handleSubmit}
          className="ams-modal__action"
          id="submit-button"
          disabled={!canSubmit}
        >
          Apply
        </ButtonPrimary>
      </ModalFooter>
    </Modal>
  );
};
